document.addEventListener("DOMContentLoaded", () => {
  window.AddItemToCart = function( prodVarID, qty = 1 ){ 
    const prodForm = document.querySelector('#product_form_')
    if ( !prodForm ) return;

    const prodFormID = prodForm.querySelector('[name="id"]');
    const prodFormQty = prodForm.querySelector('[name="quantity"]');
    prodFormID.value = prodVarID;
    prodFormQty.value = qty;
    prodForm.submit();
  }
  
});

